import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { guaranteeItems } from '../data/framework';
export function Guarantee() {
  return <section className="w-full bg-cream px-4 py-16 sm:py-24" data-id="element-154" data-mp="222mzz36b0rqw">
      <div className="mx-auto max-w-3xl" data-id="element-155" data-mp="1x5d4b5sbnjum">
        <div className="mx-auto mb-8 flex h-32 w-32 flex-col items-center justify-center rounded-full border-4 border-dashed border-gold bg-brand-dark text-center text-white" data-id="element-156" data-mp="1x28qrhsyvbra">
          <ShieldCheckIcon className="h-8 w-8 text-gold" aria-hidden="true" data-id="element-157" data-mp="14h8vwcid8so8" />
          <span className="mt-1 font-serif text-3xl font-black leading-none" data-id="element-158" data-mp="1j5luzicr2rmy">7-Day</span>
          <span className="text-[11px] font-bold uppercase tracking-widest text-white/80" data-id="element-159" data-mp="1edkaj95fhulu">Guarantee</span>
        </div>

        <SectionHeading eyebrow="Your 7-Day Guarantee" title="Explore Perio Blueprint™ Before Deciding Whether It’s Right for You" intro="I want you to have the opportunity to review the material and decide whether it fits your educational and professional needs. That’s why your purchase comes with a 7-day guarantee, subject to the published refund terms." data-id="element-160" data-mp="qmye6f4sdyro" />

        <p className="mt-10 font-bold text-ink" data-id="element-161" data-mp="yqmczmwr3roy">During that period, you can:</p>
        <ul className="mt-4 grid gap-3 sm:grid-cols-2" data-id="element-162" data-mp="12r6airl8kxbm">
          {guaranteeItems.map(g => <li key={g} className="flex gap-3 rounded-xl bg-white px-4 py-3 text-[16px] text-ink ring-1 ring-ink/5" data-id="element-163" data-mp="61ffmr91985a">
              <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-164" data-mp="b0jmhb8hitsg" />
              {g}
            </li>)}
        </ul>

        <div className="mt-8 space-y-3 text-center text-[17px] leading-relaxed text-ink/85" data-id="element-165" data-mp="k06nhvxaxxkz">
          <p data-id="element-166" data-mp="1qgr404f0ncz5">
            If the product doesn’t meet your expectations, follow the refund instructions provided with your purchase
            within the guarantee period.
          </p>
          <p className="font-serif text-xl font-bold text-brand-dark" data-id="element-167" data-mp="3riqd2iocxbrp">
            My goal is to make your decision straightforward and transparent.
          </p>
        </div>

        <div className="mt-10" data-id="element-168" data-mp="3nj7rrlsmiyoc">
          <CTAButton label="Get Perio Blueprint™ — 7-Day Guarantee" data-id="element-169" data-mp="5b9wru0vk9n4" />
        </div>
      </div>
    </section>;
}